<template>
  <div>
    <div class="filter-header d-flex">
      <button class="btn btn-purple align-self-start" @click="togglePanel"><i class="fas fa-filter"></i></button>
      <slot name="buttons"></slot>
    </div>
    <div class="filter-header d-flex">
      <applied-filters
        :items="appliedLabels"
        @filter-remove="onFilterRemove"
      ></applied-filters>
    </div>
    <el-collapse-transition>
      <div v-show="isPanelVisible">
        <div class="row mt-2">
          <component
            v-for="item in list"
            :key="item.name"
            :is="item.component"
            :name="item.name"
            :values="values"
            :pending-values="pending"
            :data="item.data"
            :class="item.classes"
            @change="onChange"
            @labels-changed="onLabelsChanged"
          ></component>
        </div>
        <button class="btn btn-default" @click="apply">Apply</button>
        <button class="btn btn-default" @click="hide">Hide</button>
        <button class="btn btn-default" @click="reset">Reset</button>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import BaseFilter from "./index";

export default {
  extends: BaseFilter,
}
</script>

<style scoped>

</style>
